import styled from 'styled-components';

export const DictionaryItemsListContainer = styled.div`
  border-bottom: 1px solid #dbdbdb;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
  }
`;

export const StyledListItem = styled.div`
  font-size: 16px;
  border-top: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  border-left: 1px solid #dbdbdb;
  background-color: white;
  padding: 1rem;
`;

export const InputListItem = styled(StyledListItem)`
  padding: 0.56rem;
`;

export const ListLabel = styled.div`
  font-size: 14px;
  color: #9e9e9e;
  padding-left: 5px;
  padding-bottom: 3px;
`;
